import { KNOWN_CORONAVIRUS_TERMS } from "./constants"

export const coronavirusSearch = search => {
  if (!search) {
    return false
  }
  let key, value, result
  for (key in KNOWN_CORONAVIRUS_TERMS) {
    if (
      KNOWN_CORONAVIRUS_TERMS.hasOwnProperty(key) &&
      !isNaN(parseInt(key, 10))
    ) {
      value = KNOWN_CORONAVIRUS_TERMS[key]
      if (value.substring(0, search.length) === search) {
        result = value
        break
      }
    }
  }
  return !!result
}



// WEBPACK FOOTER //
// ./assets/integration/utils.js